import React from "react";

import {

  Alert,

  Box,

  Button,

  Grid,

  TextField,

} from "@mui/material";

import AddRoundedIcon from "@mui/icons-material/AddRounded";

import {

  EditorSection,

  EditorFormNav,

  EditorListItem,

  EditorListHeader,

} from "./institutional/InstitutionalEditorParts";

import InstitutionalIconPicker from "./shared/InstitutionalIconPicker";

import { emptyRodapePage } from "../../utils/rodapePageContent";



const emptyChip = () => ({ icon: "", eyebrow: "", title: "", subtitle: "" });

const emptyPhone = () => ({ label: "", number: "", href: "", note: "" });

const emptyQuickLink = () => ({ label: "", href: "" });



const RODAPE_NAV = [

  { id: "sec-rodape-tagline", label: "Frase principal" },

  { id: "sec-rodape-chips", label: "Destaques" },

  { id: "sec-rodape-phones", label: "Telefones" },

  { id: "sec-rodape-links", label: "Atalhos" },

  { id: "sec-rodape-social", label: "Redes" },

];



export default function RodapeEditor({ value, onChange }) {

  const v = value?.format === "rodape.v1" ? value : emptyRodapePage();

  const set = (patch) => onChange({ ...v, ...patch });



  const chips = Array.isArray(v.chips) ? v.chips : [];

  const phones = Array.isArray(v.phones) ? v.phones : [];

  const quickLinks = Array.isArray(v.quickLinks) ? v.quickLinks : [];



  const setChip = (i, patch) => {

    const next = [...chips];

    next[i] = { ...next[i], ...patch };

    set({ chips: next });

  };



  const setPhone = (i, patch) => {

    const next = [...phones];

    next[i] = { ...next[i], ...patch };

    set({ phones: next });

  };



  const setQuickLink = (i, patch) => {

    const next = [...quickLinks];

    next[i] = { ...next[i], ...patch };

    set({ quickLinks: next });

  };



  return (

    <Box sx={{ mt: 0.5 }}>

      <Alert severity="info" sx={{ mb: 2 }}>

        Textos do rodapé do site. As colunas de links do menu ficam em <strong>Links do rodapé</strong>.

      </Alert>



      <EditorFormNav sections={RODAPE_NAV} />



      <EditorSection

        id="sec-rodape-tagline"

        title="Frase principal"

        subtitle="Slogan e texto de apresentação no topo do rodapé"

        defaultExpanded

      >

        <Grid container spacing={2}>

          <Grid item xs={12} sm={6}>

            <TextField

              fullWidth

              label="Destaque (ex.: Vai viajar?)"

              value={v.taglineHighlight || ""}

              onChange={(e) => set({ taglineHighlight: e.target.value })}

            />

          </Grid>

          <Grid item xs={12} sm={6}>

            <TextField

              fullWidth

              label="Complemento (ex.: Vai de Guerino.)"

              value={v.tagline || ""}

              onChange={(e) => set({ tagline: e.target.value })}

            />

          </Grid>

          <Grid item xs={12}>

            <TextField

              fullWidth

              multiline

              minRows={2}

              label="Subtítulo"

              value={v.subtitle || ""}

              onChange={(e) => set({ subtitle: e.target.value })}

            />

          </Grid>

        </Grid>

      </EditorSection>



      <EditorSection

        id="sec-rodape-chips"

        title="Destaques com ícone"

        subtitle="Estrada, Frota, SAC — cartões pequenos com ícone"

        badge={chips.length || null}

        defaultExpanded={chips.length > 0}

      >

        <EditorListHeader

          onAdd={() => set({ chips: [...chips, emptyChip()] })}

          addLabel="+ Adicionar destaque"

        />

        {chips.map((chip, i) => (

          <EditorListItem

            key={i}

            index={i}

            title={chip.title ? `${chip.eyebrow || "Destaque"}: ${chip.title}` : `Destaque ${i + 1}`}

            summary={chip.subtitle}

            defaultExpanded={i === chips.length - 1}

            onDelete={() => set({ chips: chips.filter((_, idx) => idx !== i) })}

          >

            <InstitutionalIconPicker

              value={chip.icon || ""}

              onChange={(icon) => setChip(i, { icon })}

              label="Ícone"

            />

            <Grid container spacing={1.5}>

              <Grid item xs={12} sm={4}>

                <TextField

                  fullWidth

                  size="small"

                  label="Etiqueta"

                  value={chip.eyebrow || ""}

                  onChange={(e) => setChip(i, { eyebrow: e.target.value })}

                  placeholder="Estrada"

                />

              </Grid>

              <Grid item xs={12} sm={4}>

                <TextField

                  fullWidth

                  size="small"

                  label="Título"

                  value={chip.title || ""}

                  onChange={(e) => setChip(i, { title: e.target.value })}

                />

              </Grid>

              <Grid item xs={12} sm={4}>

                <TextField

                  fullWidth

                  size="small"

                  label="Subtítulo"

                  value={chip.subtitle || ""}

                  onChange={(e) => setChip(i, { subtitle: e.target.value })}

                />

              </Grid>

            </Grid>

          </EditorListItem>

        ))}

      </EditorSection>



      <EditorSection

        id="sec-rodape-phones"

        title="Telefones em destaque"

        subtitle="Números SAC e outros telefones clicáveis"

        badge={phones.length || null}

        defaultExpanded={false}

      >

        <EditorListHeader

          onAdd={() => set({ phones: [...phones, emptyPhone()] })}

          addLabel="+ Adicionar telefone"

        />

        {phones.map((phone, i) => (

          <EditorListItem

            key={i}

            index={i}

            title={phone.label || `Telefone ${i + 1}`}

            summary={phone.number}

            defaultExpanded={i === phones.length - 1}

            onDelete={() => set({ phones: phones.filter((_, idx) => idx !== i) })}

          >

            <Grid container spacing={1.5}>

              <Grid item xs={12} sm={6}>

                <TextField

                  fullWidth

                  size="small"

                  label="Nome (ex.: SAC)"

                  value={phone.label || ""}

                  onChange={(e) => setPhone(i, { label: e.target.value })}

                />

              </Grid>

              <Grid item xs={12} sm={6}>

                <TextField

                  fullWidth

                  size="small"

                  label="Número exibido"

                  value={phone.number || ""}

                  onChange={(e) => setPhone(i, { number: e.target.value })}

                />

              </Grid>

              <Grid item xs={12} sm={6}>

                <TextField

                  fullWidth

                  size="small"

                  label="Link para ligar"

                  value={phone.href || ""}

                  onChange={(e) => setPhone(i, { href: e.target.value })}

                  placeholder="tel:08007700600"

                  helperText="Use tel: seguido do número"

                />

              </Grid>

              <Grid item xs={12} sm={6}>

                <TextField

                  fullWidth

                  size="small"

                  label="Observação (opcional)"

                  value={phone.note || ""}

                  onChange={(e) => setPhone(i, { note: e.target.value })}

                />

              </Grid>

            </Grid>

          </EditorListItem>

        ))}

      </EditorSection>



      <EditorSection

        id="sec-rodape-links"

        title="Atalhos rápidos"

        subtitle="Links curtos no rodapé"

        badge={quickLinks.length || null}

        defaultExpanded={false}

      >

        {quickLinks.map((link, i) => (

          <EditorListItem

            key={i}

            index={i}

            title={link.label || `Atalho ${i + 1}`}

            summary={link.href}

            defaultExpanded={i === quickLinks.length - 1}

            onDelete={() => set({ quickLinks: quickLinks.filter((_, idx) => idx !== i) })}

          >

            <Grid container spacing={1.5}>

              <Grid item xs={12} sm={6}>

                <TextField

                  fullWidth

                  size="small"

                  label="Texto do link"

                  value={link.label || ""}

                  onChange={(e) => setQuickLink(i, { label: e.target.value })}

                />

              </Grid>

              <Grid item xs={12} sm={6}>

                <TextField

                  fullWidth

                  size="small"

                  label="Para onde leva"

                  value={link.href || ""}

                  onChange={(e) => setQuickLink(i, { href: e.target.value })}

                />

              </Grid>

            </Grid>

          </EditorListItem>

        ))}

        <Button

          size="small"

          startIcon={<AddRoundedIcon />}

          onClick={() => set({ quickLinks: [...quickLinks, emptyQuickLink()] })}

          sx={{ mt: 1 }}

        >

          Adicionar atalho

        </Button>

      </EditorSection>



      <EditorSection

        id="sec-rodape-social"

        title="Redes sociais"

        subtitle="Título da área de redes no rodapé"

        defaultExpanded={false}

      >

        <TextField

          fullWidth

          label="Título da seção"

          value={v.socialTitle || ""}

          onChange={(e) => set({ socialTitle: e.target.value })}

          placeholder="Siga a Guerino Seiscento"

        />

      </EditorSection>

      <EditorSection
        id="sec-rodape-legal"
        title="Legal e acessibilidade"
        subtitle="Linha de CNPJ, logo e atalho de acessibilidade"
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              minRows={2}
              label="Linha legal (CNPJ / endereço)"
              value={v.legalLine || ""}
              onChange={(e) => set({ legalLine: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Texto alternativo do logo"
              value={v.logoAlt || ""}
              onChange={(e) => set({ logoAlt: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Rótulo acessibilidade"
              value={v.accessibilityLabel || ""}
              onChange={(e) => set({ accessibilityLabel: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Link acessibilidade"
              value={v.accessibilityHref || ""}
              onChange={(e) => set({ accessibilityHref: e.target.value })}
            />
          </Grid>
        </Grid>
      </EditorSection>

    </Box>

  );

}


